// JsFromRoutes CacheKey fa3ae71188c8d08732710e7650698eb6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/dashboard'),
}
